import { createContext } from "react";

export const defaultFilters = {
  period: { label: "All", value: "All", description: "Period: Today" },
  status: { label: "All", value: "All", description: "Status: All" },
};
export const FiltersContext = createContext({
  filters: { ...defaultFilters },
  setFilters: () => {},
});
